var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaiverApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-935 -952) translate(935 953)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16,
    y: 4,
    fill: "#32325D",
    rx: 4
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontFamily: "OpenSans-Bold, Open Sans",
    fontSize: 12,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 3,
    y: 17
  }, "W")), /*#__PURE__*/React.createElement("g", {
    fill: "#2ECE89",
    stroke: "#FFF",
    transform: "translate(11)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 5
  }))), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M13 5L15 7 19 3",
    transform: "translate(-935 -952) translate(935 953)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiverApproved);
export default __webpack_public_path__ + "static/media/waiver-approved.e7afb1c5b9d5d696ba40ef4dd5caa5b0.svg";
export { ForwardRef as ReactComponent };